import { useState, useMemo } from "react"
import { useRequest } from "ahooks";
import { Card } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { DEFAULT_PAGE_DATA as DEFAULT_QUERY_PAGE_DATA, generateTableColumns } from "./config";
import { AmountServer } from "../../../server";

const server = AmountServer.InternationalRemittanceCurrencyConversionList;

export const InternationalRemittanceCurrencyConversionList = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_QUERY_PAGE_DATA });

    //获取表格数据
    const { run } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    const getTableColumns = useMemo(() => {
        return generateTableColumns();
    }, []);

    return (
        <div>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="quoteId"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run(currentPage);
                    }}
                />
            </Card >
        </div>
    );
}
